import { costModel } from "../lib/costModel.js";
import { fmtEurCompact } from "../lib/localization.js";

export function CashflowSection({ purchasePrice, bedrooms, concelho, subtitle }) {
  const cm = costModel(purchasePrice, bedrooms, concelho);
  if (!cm) return null;
  const positive = cm.net_cashflow_yearly >= 0;

  return (
    <section className="cashflow-section">
      <h4>Cashflow-projectie</h4>
      {subtitle && <div className="cf-subtitle">{subtitle}</div>}
      <table className="cf-table">
        <tbody>
          <tr className="cf-group-head"><td colSpan="2">Eenmalige aanschaf</td></tr>
          <tr><td>Koopprijs huis</td><td className="cf-val">{fmtEurCompact(cm.purchase_price)}</td></tr>
          <tr className="cf-sub"><td>+ IMT (~7% effectief)</td><td className="cf-val">{fmtEurCompact(cm.acquisition.imt)}</td></tr>
          <tr className="cf-sub"><td>+ Imposto do Selo (0,8%)</td><td className="cf-val">{fmtEurCompact(cm.acquisition.stamp_duty)}</td></tr>
          <tr className="cf-sub"><td>+ Advocaat, notaris, registratie</td><td className="cf-val">{fmtEurCompact(cm.acquisition.lawyer + cm.acquisition.notary + cm.acquisition.registration)}</td></tr>
          <tr className="cf-total"><td>Totaal aanschaf jaar 0</td><td className="cf-val">{fmtEurCompact(cm.acquisition.grand_total)}</td></tr>

          <tr className="cf-group-head"><td colSpan="2">Jaarlijkse vaste lasten</td></tr>
          <tr className="cf-sub"><td>IMI ({cm.imi_rate}% × VPT {fmtEurCompact(cm.vpt)})</td><td className="cf-val">{fmtEurCompact(cm.annual.imi)}</td></tr>
          {cm.annual.aimi > 0 && <tr className="cf-sub"><td>AIMI (boven €600k VPT)</td><td className="cf-val">{fmtEurCompact(cm.annual.aimi)}</td></tr>}
          <tr className="cf-sub"><td>Onderhoud (1,5%)</td><td className="cf-val">{fmtEurCompact(cm.annual.maintenance)}</td></tr>
          <tr className="cf-sub"><td>Water, stroom, internet, verzekering</td><td className="cf-val">{fmtEurCompact(cm.annual.utilities)}</td></tr>
          <tr className="cf-total"><td>Totaal kosten/jaar</td><td className="cf-val">{fmtEurCompact(cm.annual.total)}</td></tr>

          <tr className="cf-group-head"><td colSpan="2">Retreat-inkomsten/jaar</td></tr>
          {cm.revenue ? (
            <>
              <tr className="cf-rev"><td>+ Bruto revenue</td><td className="cf-val">{fmtEurCompact(cm.revenue.gross)}</td></tr>
              <tr className="cf-rev cf-sub"><td>└ minus 30% operating costs</td><td className="cf-val">{fmtEurCompact(-cm.revenue.opex)}</td></tr>
              <tr className="cf-rev cf-total"><td>= Netto retreat-revenue</td><td className="cf-val">{fmtEurCompact(cm.revenue.net)}</td></tr>
            </>
          ) : (
            <tr><td colSpan="2" className="cf-empty">Onvoldoende kamers voor retreat-revenue</td></tr>
          )}

          <tr className={`cf-net ${positive ? "positive" : "negative"}`}>
            <td>Netto cashflow per jaar</td>
            <td className="cf-val">{fmtEurCompact(cm.net_cashflow_yearly)}</td>
          </tr>
          {cm.breakEvenYears && cm.breakEvenYears < 100 && (
            <tr className="cf-meta">
              <td>Aanschafkosten terugverdiend in</td>
              <td className="cf-val">~{cm.breakEvenYears} jaar</td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="cf-disclaimer">
        Indicatief — IMT ~7% effectief, VPT ~60% van marktprijs, bezetting + nachtprijs uit YAML. Voor echte planning: PT-belastingadviseur.
      </div>
    </section>
  );
}
